module.exports = __webpack_public_path__ + "static/media/st-barts.5921f640.svg";